import React from 'react';
import Styled from '../../UserAccountPage.styles';
import { ReactComponent as RightArrow } from '../../../../../../assets/icons/arrow.svg';
import { useHistory } from 'react-router-dom';

const preStyle = {
  whiteSpace: 'pre-wrap',        // keep formatting but allow wrapping
  overflowWrap: 'anywhere',      // break long unbroken strings (best fix)
  wordBreak: 'break-word',       // fallback for older browsers
  maxWidth: '100%',
  overflowX: 'auto',             // fallback if something still overflows
};

const LogDetails = () => {
  const history = useHistory();
  const log = history.location.state?.data;

  const request = log.request;
  const response = log.response;

  return (
    <Styled.DataContainer>
      <Styled.BackArrow>
        <RightArrow onClick={() => history.goBack()} />
        <Styled.VisitTitle>
          {log.calledMethod} {log.path}
        </Styled.VisitTitle>
      </Styled.BackArrow>

      <pre style={preStyle}>{JSON.stringify(log, null, 2)}</pre>

      {request && (
        <div>
          Request:
          <pre style={preStyle}>
            {JSON.stringify(JSON.parse(request), null, 2)}
          </pre>
        </div>
      )}

      {response && !log.path.includes('/api/Integrations/File/') && (
        <div>
          Response:
          <pre style={preStyle}>
            {(() => {
              try {
                return JSON.stringify(JSON.parse(response), null, 2);
              } catch {
                return response;
              }
            })()}
          </pre>
        </div>
      )}
    </Styled.DataContainer>
  );
};

export default LogDetails;
